<!-- Cancel Task Choice Dialog Component -->
<div class="cancel-task-choice-dialog-container">

  <!-- Dialog Content -->
  <mat-dialog-content class="dialog-content">
    <div class="dialog-layout">

      <!-- Icon Section -->
      <div class="dialog-icon-wrapper">
        <div class="dialog-icon">
          <mat-icon class="icon">help_outline</mat-icon>
        </div>
      </div>

      <!-- STEP 1: choose selected-date vs all-future -->
      <div class="dialog-text" *ngIf="step === 1">
        <h1 mat-dialog-title class="dialog-title">
          Cancel Task
        </h1>

        <p class="dialog-message">
          How would you like to cancel "{{ data.taskTitle }}"?
        </p>

        <!-- Choice Cards -->
        <div class="choice-cards">
          <!-- Cancel for Selected Date Only -->
          <div class="choice-card" (click)="selectSelectedDate()">
            <div class="choice-icon">
              <mat-icon>event</mat-icon>
            </div>
            <div class="choice-content">
              <h3 class="choice-title">Cancel for Selected Date Only</h3>
              <p class="choice-description">
                This will cancel the task only for the currently selected date. The task will continue on other scheduled dates.
              </p>
            </div>
          </div>

          <!-- Cancel All Occurrences -->
          <div class="choice-card" (click)="goToAllFutureStep()">
            <div class="choice-icon">
              <mat-icon>cancel_schedule_send</mat-icon>
            </div>
            <div class="choice-content">
              <h3 class="choice-title">Cancel All Occurrences</h3>
              <p class="choice-description">
                Choose to cancel every occurrence, or cancel occurrences from a date you pick.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- STEP 2: choose the all-future scope -->
      <div class="dialog-text" *ngIf="step === 2">
        <h1 mat-dialog-title class="dialog-title">
          Cancel All Occurrences
        </h1>

        <p class="dialog-message">
          How far should the cancellation of "{{ data.taskTitle }}" reach?
        </p>

        <mat-radio-group class="scope-options" [(ngModel)]="scope">
          <!-- Cancel every occurrence -->
          <mat-radio-button class="scope-option" [value]="AllFutureScope.ALL">
            <span class="scope-title">Cancel all tasks</span>
            <span class="scope-description">
              Cancels every occurrence from the start. No tasks remain.
            </span>
          </mat-radio-button>

          <!-- Cancel from a chosen date -->
          <mat-radio-button class="scope-option" [value]="AllFutureScope.FROM_DATE">
            <span class="scope-title">Cancel from a selected date</span>
            <span class="scope-description">
              Cancels all tasks from the chosen date onward. Earlier tasks stay visible.
            </span>
          </mat-radio-button>
        </mat-radio-group>

        <!-- Date picker, only relevant when cancelling from a date -->
        <mat-form-field appearance="outline" class="from-date-field"
                        *ngIf="scope === AllFutureScope.FROM_DATE">
          <mat-label>Cancel from</mat-label>
          <input matInput
                 [matDatepicker]="fromPicker"
                 [min]="minDate"
                 [(ngModel)]="fromDate"
                 readonly
                 (click)="fromPicker.open()" />
          <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
          <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>
      </div>

    </div>
  </mat-dialog-content>

  <!-- Dialog Actions -->
  <mat-dialog-actions class="dialog-actions">

    <!-- STEP 1 actions -->
    <button *ngIf="step === 1"
      mat-stroked-button
      type="button"
      class="cancel-button"
      (click)="onCancel()">
      <mat-icon>close</mat-icon>
      Go Back
    </button>

    <!-- STEP 2 actions -->
    <ng-container *ngIf="step === 2">
      <button
        mat-stroked-button
        type="button"
        class="cancel-button"
        (click)="backToChoices()">
        <mat-icon>arrow_back</mat-icon>
        Go Back
      </button>
      <button
        mat-flat-button
        color="warn"
        type="button"
        class="confirm-button"
        [disabled]="isConfirmDisabled"
        (click)="confirmAllFuture()">
        <mat-icon>check</mat-icon>
        Confirm
      </button>
    </ng-container>

  </mat-dialog-actions>

</div>
